import React from 'react'
import { TraceDiffItem } from '../../domain/Trace'
import { DiffItem } from './DiffItem'

interface Props {
    items: TraceDiffItem[]
    sort: 'wt' | 'excl_wt'
    onSortChange: (sortKey: Props['sort']) => void
}
interface State {}

export class DiffTable extends React.Component<Props, State> {
    public render() {
        const { items, sort, onSortChange } = this.props

        return (
            <table className="table table-striped table-bordered table-condensed">
                <thead>
                    <tr>
                        <th />
                        <th>Type</th>
                        <th>Call</th>
                        <th>
                            Total Faster{' '}
                            <a className="pull-right" onClick={() => onSortChange('wt')}>
                                <span className={sort === 'wt' ? 'fa fa-sort-desc' : 'fa fa-sort'} />
                            </a>
                        </th>
                        <th>
                            Self Faster{' '}
                            <a className="pull-right" onClick={() => onSortChange('excl_wt')}>
                                <span className={sort === 'excl_wt' ? 'fa fa-sort-desc' : 'fa fa-sort'} />
                            </a>
                        </th>
                    </tr>
                </thead>
                <tbody>
                    {items.map(item => (
                        <DiffItem key={item.call} stats={item} />
                    ))}
                </tbody>
            </table>
        )
    }
}
